import { tabQuery } from "../../theme";

const headerMenuStyles = {
  userMenuWrap: {
    justifyContent: "space-between",

    padding: "0 2rem",
    [tabQuery]: {
      padding: "0 1.5rem",
    },
    height: 75,
  },
  userBtn: {
    height: "auto",
    textAlign: "left",
  },
};

export default headerMenuStyles;
